import apiClient from "./apiClient";
const resource = "/schedule";

export default {
  async getAll(params = {}) {
    return apiClient.get(`${resource}`, { params });
  },
  async create(data) {
    return apiClient.post(`${resource}`, data);
  },
  async getById(uuid) {
    return apiClient.get(`${resource}/${uuid}`);
  },
  async update(data, uuid) {
    return apiClient.put(`${resource}/${uuid}`, data);
  },
  async delete(uuid) {
    return apiClient.delete(`${resource}/${uuid}`);
  },
  async getFullyBookedCategories(date) {
    return apiClient.get(`/booked-categories`, {
      params: { date },
    });
  },
  async getBookedRooms(date) {
    return apiClient.get(`/booked-rooms?date=${date}`);
  },

  async search(keyword) {
    return apiClient.get(`${resource}/search?keyword=${keyword}`);
  },
};
